import HttpClienteToken from '../../services/HttpClientToken';

import { AsentamientoParser, AsentamientoProps, ObtenerCodigosPostalesParams } from '../../interfaces/catalogos/AsentamientoInterface';

export const ObtenerCodigosPostales = ( idMunicipio: number ) => {

    return new Promise<ObtenerCodigosPostalesParams[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get(`/Api/Asentamiento/ObtenerCodigosPostales/${ idMunicipio }`, token)
            .then( ({ data } : { data : ObtenerCodigosPostalesParams[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ObtenerAsentamientos = ( param: AsentamientoProps ) => {

    return new Promise<AsentamientoProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/Asentamiento/ObtenerAsentamientos/', param, token)
            .then( ({ data } : { data : AsentamientoProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ObtenerAsentamientosMunicipio = ( id: number ) => {

    return new Promise<AsentamientoParser[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/Asentamiento/ObtenerAsentamientosMunicipio/' + id, token)
            .then( ({ data } : { data : AsentamientoParser[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const Asentamientos = () => {

    return new Promise<AsentamientoProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/Asentamiento/', token)
            .then( ({ data } : { data : AsentamientoProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve([]);
            });
        }

    });

}

export const ActualizarAsentamiento = ( params: AsentamientoProps ) => {

    return new Promise<AsentamientoProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/Asentamiento/Actualizar', params, token)
            .then( ({ data } : { data : AsentamientoProps} ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( {
                    idAsentamiento: 0,
                    clave: '',
                    descripcion: '',
                    codigoPostal: '',
                    idTipoAsentamiento: 0,
                    idEstado: 0,
                    idMunicipio: 0,
                    idCiudad: 0,
                    activo: false,
                    idZona: 0
                });
            });
        }

    });

}

export const AgregarAsentamiento = ( params: AsentamientoProps ) => {

    return new Promise<AsentamientoProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/Asentamiento/Agregar', params, token)
            .then( ({ data } : { data : AsentamientoProps} ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( {
                    idAsentamiento: 0,
                    clave: '',
                    descripcion: '',
                    codigoPostal: '',
                    idTipoAsentamiento: 0,
                    idEstado: 0,
                    idMunicipio: 0,
                    idCiudad: 0,
                    activo: false,
                    idZona: 0
                });
            });
        }

    });

}